const translates = {
	en: {
		tooltipTitle: 'Go to point'
	},
	ru: {
		tooltipTitle: 'Перейти к точке'
	}
};
export default translates;